/* Velvet Lane cute touches: scroll-in section reveals + sparkle burst on add to cart */
/* + cart icon celebration in the header (visible even when the cart drawer opens) */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var sections = document.querySelectorAll('#MainContent .shopify-section');
    if (!sections.length || reduceMotion || !('IntersectionObserver' in window)) return;
    sections.forEach(function (el) { el.classList.add('vl-reveal'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('vl-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    sections.forEach(function (el) { io.observe(el); });
  }

  var SPARKLE_SVG = '<svg viewBox="0 0 24 24" width="100%" height="100%"><path d="M12 0 L14.5 9.5 L24 12 L14.5 14.5 L12 24 L9.5 14.5 L0 12 L9.5 9.5 Z" fill="COLOR"/></svg>';
  var HEART_SVG = '<svg viewBox="0 0 24 24" width="100%" height="100%"><path d="M12 21 C12 21 1 13.5 1 6.5 C1 3.5 3.5 1.5 6.5 1.5 C9 1.5 11 3 12 5.5 C13 3 15 1.5 17.5 1.5 C20.5 1.5 23 3.5 23 6.5 C23 13.5 12 21 12 21 Z" fill="COLOR"/></svg>';
  var SHAPES = [
    { type: 'sparkle', colors: ['#F8B7D5', '#F472B6', '#FBD3E8', '#EC4899'] },
    { type: 'heart', colors: ['#D63384', '#F8B7D5', '#BE185D'] }
  ];

  function burst(x, y) {
    if (reduceMotion) return;
    for (var i = 0; i < 14; i++) {
      var s = document.createElement('span');
      s.className = 'vl-sparkle';
      s.setAttribute('aria-hidden', 'true');
      // Pick sparkle (70%) or heart (30%)
      var shape = Math.random() < 0.7 ? SHAPES[0] : SHAPES[1];
      var color = shape.colors[Math.floor(Math.random() * shape.colors.length)];
      var svg = (shape.type === 'sparkle' ? SPARKLE_SVG : HEART_SVG).replace(/COLOR/g, color);
      s.innerHTML = svg;
      var size = 10 + Math.random() * 14;
      s.style.width = size + 'px';
      s.style.height = size + 'px';
      var angle = Math.random() * Math.PI * 2;
      var dist = 40 + Math.random() * 70;
      s.style.left = x + 'px';
      s.style.top = y + 'px';
      s.style.setProperty('--dx', Math.cos(angle) * dist + 'px');
      s.style.setProperty('--dy', (Math.sin(angle) * dist - 60) + 'px');
      document.body.appendChild(s);
      (function (el) {
        setTimeout(function () { el.remove(); }, 1150);
      })(s);
    }
  }

  function initSparkles() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest(
        'button[name="add"], .product-form__submit, [data-add-to-cart], .quick-add__submit'
      );
      if (!btn) return;
      var form = btn.closest('form');
      var action = form ? form.getAttribute('action') || '' : '';
      var isAdd = btn.hasAttribute('name') && btn.getAttribute('name') === 'add';
      if (!isAdd && action.indexOf('/cart/add') === -1) return;
      burst(e.clientX, e.clientY);
    }, { passive: true });
  }

  function initCartCelebration() {
    if (reduceMotion) return;
    // Watch the header cart count; when it goes up, celebrate the cart icon.
    // The drawer covers the button sparkles, but the header icon is always visible.
    var lastCount = -1;
    function getCount() {
      var el = document.querySelector('.cart-bubble__text-count');
      if (!el) return -1;
      var n = parseInt((el.textContent || '').replace(/\D/g, ''), 10);
      return isNaN(n) ? 0 : n;
    }
    function celebrate() {
      var icon = document.querySelector('.header-actions__cart-icon');
      if (!icon) return;
      icon.classList.remove('vl-cart-celebrate');
      // Force reflow so the animation restarts on rapid adds
      void icon.offsetWidth;
      icon.classList.add('vl-cart-celebrate');
      // Little sparkle puff around the icon
      var r = icon.getBoundingClientRect();
      burst(r.left + r.width / 2, r.top + r.height / 2);
      setTimeout(function () { icon.classList.remove('vl-cart-celebrate'); }, 1600);
    }
    function check() {
      var n = getCount();
      if (n < 0) return;
      if (lastCount >= 0 && n > lastCount) {
        celebrate();
        showAddedToast();
      }
      lastCount = n;
    }
    // Poll lightly; MutationObserver on theme custom elements can be flaky
    lastCount = getCount();
    setInterval(check, 800);
    // Keep the cart drawer from auto-opening so the celebration is visible.
    // A cute toast confirms the add instead.
    keepDrawerClosed();
    // Never let the toast cover the cart total: the moment any drawer
    // (cart, menu) opens, the toast bows out.
    document.addEventListener('theme-drawer:open', dismissToast);
    document.addEventListener('theme-drawer:open', function () { setReferWidgetHidden(true); });
    document.addEventListener('theme-drawer:close', function () { setReferWidgetHidden(false); });
  }

  function keepDrawerClosed() {
    // The theme auto-opens the cart drawer because <cart-drawer-component>
    // has an "auto-open" attribute (from the auto_open_cart_drawer setting).
    // Removing the attribute stops the auto-popup; manual cart icon clicks
    // still open the drawer normally. We show a toast instead.
    function stripAutoOpen() {
      document.querySelectorAll('cart-drawer-component[auto-open]').forEach(function (el) {
        el.removeAttribute('auto-open');
      });
    }
    stripAutoOpen();
    // Re-strip in case the theme re-renders the drawer (e.g. after cart updates)
    new MutationObserver(stripAutoOpen).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['auto-open']
    });
  }

  var toastTimer = null;

  // The refer-and-earn app widget floats above the cart drawer (covering the
  // express checkout buttons) and would overlap the centered toast on phones.
  // Tuck it away while a drawer or the toast is up. Only ever un-hide it
  // when we were the ones who hid it.
  function setReferWidgetHidden(hidden) {
    var w = document.querySelector('.sca_aff_customer_refer_button');
    if (!w) return;
    if (hidden) {
      if (w.style.display !== 'none') {
        w.setAttribute('data-vl-hidden', '1');
        w.style.display = 'none';
      }
    } else if (w.getAttribute('data-vl-hidden') === '1') {
      w.removeAttribute('data-vl-hidden');
      w.style.display = '';
    }
  }

  function dismissToast() {
    // If any drawer (cart, menu) opens while the toast is up, clear it at
    // once so it never sits on top of the cart total.
    if (toastTimer) { clearTimeout(toastTimer); toastTimer = null; }
    setReferWidgetHidden(false);
    var t = document.querySelector('.vl-toast');
    if (!t) return;
    t.classList.remove('vl-toast--show');
    setTimeout(function () { t.remove(); }, 400);
  }

  function showAddedToast() {
    // Cute on-brand toast notification instead of the auto-opening drawer
    var existing = document.querySelector('.vl-toast');
    if (existing) existing.remove();
    if (toastTimer) { clearTimeout(toastTimer); toastTimer = null; }
    // The widget would overlap the centered toast on phones, so it bows out
    // for the toast's moment in the spotlight, then returns.
    setReferWidgetHidden(true);
    var t = document.createElement('div');
    t.className = 'vl-toast';
    t.setAttribute('role', 'status');
    t.innerHTML = '<span class="vl-toast__bow">🎀</span> Added To Your Bag!';
    document.body.appendChild(t);
    // Trigger the slide-in
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { t.classList.add('vl-toast--show'); });
    });
    toastTimer = setTimeout(function () { toastTimer = null; dismissToast(); }, 2600);
  }

  function init() {
    initReveal();
    initSparkles();
    initCartCelebration();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
